import { useLocation } from 'react-router-dom'

import { useState } from 'react'

import { cn } from '@/lib/utils'
import { useBusiness } from '@/contexts/BusinessContext'

import { AssistantComposer } from './AssistantComposer'
import { assistantText } from './assistantText'
import { AssistantSuggestions, RecentsList } from './AssistantPanel'
import { AssistantSetupCards } from './AssistantSetupCards'
import { useAssistant } from './AssistantProvider'

/** The floating composer at the bottom of every page while the panel is closed. */
export const AssistantDock = () => {
  const { isOpen, capabilities } = useAssistant()
  const { pathname } = useLocation()
  // Home has the large prompt instead.
  if (isOpen || !capabilities?.enabled || pathname === '/') return null
  return (
    <div className="no-print pointer-events-none fixed inset-x-0 bottom-4 z-40 flex justify-center px-4">
      <div className="pointer-events-auto w-full max-w-[640px]">
        <AssistantComposer variant="floating" />
      </div>
    </div>
  )
}

/** The large prompt at the top of Home, with starter prompts and recents. */
export const AssistantHome = () => {
  const { language, capabilities } = useAssistant()
  const { profile } = useBusiness()
  const [showRecents, setShowRecents] = useState(false)
  const t = assistantText(language)
  if (!capabilities?.enabled) return null

  return (
    <>
    <section className="mx-auto w-full max-w-[720px] py-6">
      <h1 className={cn('mb-5 text-center text-display', language === 'bn' && 'font-bn')}>
        {t.homeHeading(profile?.name || (language === 'bn' ? 'আপনার স্টোর' : 'your store'))}
      </h1>
      <AssistantComposer variant="home" onShowRecents={() => setShowRecents((v) => !v)} />
      <div className="mt-3 px-2">
        {showRecents ? <RecentsList onPick={() => setShowRecents(false)} /> : <AssistantSuggestions />}
      </div>
    </section>
    <AssistantSetupCards />
    </>
  )
}
